<template>
  <div class="personalInformation">
    <!-- 标题栏 -->
    <van-nav-bar left-arrow :right-text="allowEdit?'取消':'修改'" title="个人信息" @click-left="onClickLeft" @click-right="onEdit" />
    <div class="kqb-form-list">
      <div class="kqb-form-list-item autoHeight">
        <div class="kqb-form-list-label">头像</div>
        <div class="kqb-form-list-inner">
          <van-uploader v-model="fileList" multiple :max-count="1" preview-size="50" :disabled="!allowEdit">
            <img v-lazy="" />
          </van-uploader>
        </div>
      </div>
    </div>
    <div class="kqb-form-list">
      <div class="kqb-form-list-item navigator-arrow">
        <div class="kqb-form-list-label">用户名</div>
        <div class="kqb-form-list-inner">
          <input class="tr" v-model="postData.name" placeholder-class="placeholder-style" type="text" placeholder="请输入用户名" :disabled="!allowEdit" />
        </div>
      </div>
      <div class="kqb-form-list-item navigator-arrow">
        <div class="kqb-form-list-label">性别</div>
        <div class="kqb-form-list-inner" @click="showSexPicker = allowEdit">
          <p :class="postData.sex==='请选择性别'?'fc-999':''">{{postData.sex}}</p>
        </div>
      </div>
      <div class="kqb-form-list-item navigator-arrow">
        <div class="kqb-form-list-label">生日</div>
        <div class="kqb-form-list-inner">
          <!-- @click="showBorthPicker = true"<p :class="postData.borthDay==='请选择生日'?'fc-999':''">{{postData.borthDay}}</p> -->
          <input class="tr" type="date" v-model="postData.borthDay" placeholder="请选择生日日期" :disabled="!allowEdit" />
        </div>
      </div>
    </div>
    <div class="kqb-form-list">
      <div class="kqb-form-list-item navigator-arrow">
        <div class="kqb-form-list-label">绑定手机号</div>
        <div class="kqb-form-list-inner">
          <div class="fc-FF2D41" @click.stop="showModal = true">去绑定</div>
        </div>
      </div>
    </div>
    <div class="kqb-submit" v-if="allowEdit">
      <button class="kqb-btn kqb-btn-block bgC-FF2D41" @click='save'>保存</button>
    </div>
    <!-- 性别选择 -->
    <van-popup v-model="showSexPicker" position="bottom">
      <van-picker show-toolbar :columns="sexs" @cancel="showSexPicker = false" @confirm="onConfirmSex" />
    </van-popup>
    <!-- 生日选择 -->
    <van-popup v-model="showBorthPicker" position="bottom">
      <van-picker show-toolbar :columns="borths" @cancel="showBorthPicker = false" @confirm="onConfirmBorth" />
    </van-popup>
    <!-- 手机号码绑定 -->
    <van-overlay :show="showModal" @click="showModal = false">
      <div class="Modal-content" @click.stop>
        <div class="title">绑定手机号码</div>
        <img class="icon-close" src="img/user/personal_informationicon_close.png" @click.stop="showModal = false" />
        <div class="kqb-form-list">
          <div class="kqb-form-list-item">
            <img class="kqb-form-list-icon" src="img/user/personal_information/icon_phone.png" />
            <div class="kqb-form-list-inner">
              <input class="tl" maxlength="11" type="number" placeholder="请输入手机号" />
            </div>
          </div>
          <div class="kqb-form-list-item">
            <img class="kqb-form-list-icon" src="img/user/personal_information/icon_safe.png" />
            <div class="kqb-form-list-inner disp-flex">
              <input maxlength="8" class="tl" type="number" placeholder="请输入手机验证码" />
              <button class="kqb-btn kqb-btn-outlined verCode" :class="!allowAccess?'disable':''" @click.stop="getVerCode">{{countDown}}</button>
            </div>
          </div>
        </div>
        <button class="kqb-btn kqb-btn-block kqb-btn-round bgC-FF2D41" :data-uri="'/replacePhone'" @click.stop="pageJump">确定</button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
let miao = 60 // 倒计时
export default {
  name: 'personalInformation',
  data () {
    return {
      postData: {
        name: '',
        sex: '请选择性别',
        borthDay: '请选择生日'
      },
      fileList: [],
      showModal: false,
      allowAccess: true,
      countDown: '获取验证码',
      showSexPicker: false,
      showBorthPicker: false,
      sexs: ['男', '女'],
      borths: [],
      allowEdit: false // 是否允许修改
    }
  },
  created () {
    const thisObj = this
    thisObj.getData()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onEdit () {
      const thisObj = this
      thisObj.allowEdit = !thisObj.allowEdit
    },
    getData () {
      const thisObj = this
      thisObj.$api.post('/api/mine').then(res => {
        console.log(res)
        thisObj.pageData = res.data.userInfo
      }).catch(function (error) {
        console.log(error)
      })
    },
    // 获取验证码
    getVerCode: function () {
      const thisObj = this
      if (thisObj.allowAccess) {
        let interval = setInterval(function () {
          thisObj.countDown = '' + miao + '秒重新获取'
          thisObj.allowAccess = false
          if (miao === 0) {
            miao = 59
            clearInterval(interval)
            // let mobileNo = thisObj.data.mobile;
            thisObj.countDown = '获取验证码'
            thisObj.allowAccess = true
          }
          miao--
        }, 1000)
      }
    },
    onConfirmSex (e) {
      this.postData.sex = e
      this.showSexPicker = false
    },
    onConfirmBorth () { },
    // 页面跳转
    pageJump (e) {
      console.log(e)
      const thisObj = this
      let uri = e.target.dataset.uri
      let queryData = {}
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    save () {
      alert(JSON.stringify(this.postData))
    }
  }
}
</script>

<style lang="css" scoped>
.personalInformation {
  height: 100%;
  background: #f8fbff;
}
.userInfo {
  height: 100%;
  background-color: #fafafa;
}

.fc-FF2D41 {
  font-size: 30px;
  color: #ff2d41;
}

.bgC-FF2D41 {
  background-color: #ff2d41;
}

.kqb-form-list {
  margin: 20px 0 0;
}

.kqb-form-list:first-child {
  margin: 30px 0 0;
}

.kqb-form-list-item {
  -webkit-justify-content: space-between;
  justify-content: space-between;
  padding: 0 28px;
}

.kqb-form-list-item .kqb-form-list-label {
  min-width: 160px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(12, 12, 12, 1);
}

.kqb-form-list-item .kqb-form-list-inner {
  width: 100%;
  padding-right: 40px;
  text-align: right;
}
.kqb-form-list-item .kqb-form-list-inner p {
  font-size: 32px;
  color: #959595;
}
.kqb-form-list-item .kqb-form-list-inner p.fc-999 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
}
.kqb-form-list-item .kqb-form-list-inner input {
  min-height: initial !important;
  line-height: initial !important;
  padding: 0;
}

.kqb-form-list-item.autoHeight {
  min-height: 140px;
  height: 140px;
}

.kqb-form-list-item.autoHeight .kqb-form-list-inner {
  width: -webkit-fit-content;
  height: -webkit-fit-content;
  padding: 0;
}
.kqb-form-list-item.autoHeight .kqb-form-list-inner input {
  min-height: initial;
  line-height: initial;
}
.kqb-form-list-item.autoHeight img {
  max-width: 90px;
  width: 90px;
  height: 90px;
  margin: 0 20px 0;
}
.kqb-submit {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.kqb-submit .kqb-btn {
  width: 100%;
  margin: 0;
  color: #fff;
}

.Modal-content {
  position: absolute;
  top: 50%;
  left: 75px;
  right: 75px;
  padding: 0 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  transform: translate(0, -50%);
}

.Modal-content .kqb-form-list-icon {
  max-width: 50px;
  width: 50px;
  height: 50px;
}

.Modal-content .title {
  padding: 48px 20px;
  text-align: center;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
}

.Modal-content .icon-close {
  position: absolute;
  right: 30px;
  top: 22px;
  max-width: 28px;
  width: 28px;
  height: 28px;
  padding: 20px;
}

.Modal-content .kqb-form-list-item {
  height: 128px;
  padding: 0;
}
.Modal-content .kqb-form-list-item .kqb-form-list-inner {
  height: initial;
  padding: 0;
}
.Modal-content .kqb-form-list-item .kqb-form-list-inner input {
  padding: 0 0 0 28px;
}

.Modal-content .kqb-btn {
  width: 100%;
  height: 80px;
  line-height: 80px;
  margin: 0 0 38px 0;
  padding: 0;
  color: #fff;
}

.Modal-content button.kqb-btn.kqb-btn-outlined.verCode {
  width: 280px;
  height: 65px;
  line-height: 65px;
  margin: 0;
  padding: 0;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 45, 65, 1);
  border: 1px solid rgba(255, 45, 65, 1);
  border-radius: 5px;
}

.Modal-content button.kqb-btn.kqb-btn-outlined.verCode.disable {
  color: rgba(227, 227, 227, 1);
  /* rgba(153, 153, 153, 1); */
  border-color: rgba(227, 227, 227, 1);
}
</style>
